<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption2" ref="mySwiper" @someSwiperEvent="callback" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption1" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                    <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption3" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption4" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-scrollbar" slot="scrollbar"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption5" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10']">
                <swiper :options="swiperOption6" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="background:#bbb;">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10', 'swiperOption7']">
                <swiper :options="swiperOption7" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="background:#bbb;">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10', 'swiperOption8']">
                <swiper :options="swiperOption8" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="background:#bbb;">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10', 'swiperOption9']">
                <swiper :options="swiperOption9" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="background:#bbb;">I'm Slide {{ slide }}</swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div :class="[$style['vue-awesome-swiper'], 'mb-10', 'swiperOption10']">
                <swiper :options="swiperOption10" :class="$style['vue-awesome-swiper-view']">
                    <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" style="background:#bbb;">
                        <swiper :options="swiperOption11" v-if="index === 1" :class="$style['vue-awesome-swiper-view']">
                            <swiper-slide v-for="(slide, i) in swiperSlides" :key="i" style="background:#777;">
                                <span>I'm Child Slide {{ slide }}</span>
                            </swiper-slide>
                            <div class="swiper-pagination-v" slot="pagination"></div>
                        </swiper>
                        <span v-else>I'm Slide {{ slide }}</span>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    export default {
        name: 'carrousel',
        data() {
          return {
            swiperOption: {
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
              },
            },
            banners: [
                'https://images.pexels.com/photos/2020941/pexels-photo-2020941.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
                'https://images.pexels.com/photos/2020991/pexels-photo-2020991.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
                'https://images.pexels.com/photos/1207918/pexels-photo-1207918.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
                'https://images.pexels.com/photos/2033708/pexels-photo-2033708.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
                'https://images.pexels.com/photos/1797375/pexels-photo-1797375.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
            ],
            swiperOption1:{
                pagination: {
                  el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
            },
            swiperOption2:{
              pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                /*
                    //自定义指示器
                    clickable: true,
                    renderBullet(index, className) {
                      return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
                    }
                 */
              }
            },
            swiperOption3:{
              pagination: {
                el: '.swiper-pagination',
                type: 'progressbar'
              }
            },
            swiperOption4:{
              scrollbar: {
                el: '.swiper-scrollbar',
                hide: true
              }
            },
            swiperOption5:{
              direction: 'vertical',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption6:{
              slidesPerView: 3,
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption7:{
              slidesPerView: 'auto',
              centeredSlides: true,
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption8:{
              slidesPerView: 3,
              spaceBetween: 30,
              freeMode: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption9:{
              slidesPerView: 3,
              slidesPerColumn: 2,
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption10:{
              spaceBetween: 50,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            swiperOption11:{
              direction: 'vertical',
              spaceBetween: 50,
              grabCursor: true,
              pagination: {
                el: '.swiper-pagination-v',
                clickable: true
              }
            },
            swiperSlides: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
          }
        },
        methods:{
            callback(){}
        },
        created(){
            this.$parent.routerLoading();
        },
        computed: {
          swiper() {
            return this.$refs.mySwiper.swiper
          }
        },
        mounted() {
          // current swiper instance
          // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
          // console.log('this is current swiper instance object', this.swiper)
          this.swiper.slideTo(1, 1000, false)
        }
    }
</script>
<style module>
    .vue-awesome-swiper{
        height: 240px;
    }
    .vue-awesome-swiper-view{
        height: 100%;
        background: #f1f1f1;
    }
</style>
<style>
    .swiper-slide{
        text-align: center;
        line-height: 220px;
    }
</style>
<style scoped>
  .swiperOption7 .swiper-slide {
    width: 60%;
  }
  .swiperOption7 .swiper-slide:nth-child(2n) {
      width: 40%;
  }
  .swiperOption7 .swiper-slide:nth-child(3n) {
      width: 20%;
  }
   .swiperOption9{
        height: 450px;
    }
    .swiperOption9 .swiper-container {
        height: auto!important;
        margin-left: auto;
        margin-right: auto;
    }
    .swiperOption9 .swiper-slide {
        height: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/vue-awesome-swiper.vue